<template>
  <div class="animate__animated animate__fadeIn">
    <div class="d-flex justify-content-between">
      <div>
        <h4 class="font-weight-bold">Identificação da Família</h4>
      </div>

      <!-- <form-select
        grid="4"
        v-model="item.estado_cadastral_id"
        :itens="$root.arrays.estado_cadastral_familia"
        @change="item.estado_cadastral_id == 4 ? $emit('excluir') : ''"
        label="Estado Cadastral"
      /> -->
      <div>
        <div class="col text-right" v-if="item.transferencia">
          <p class="font-weight-light font-italic">
            <a
              href="#"
              class="router-link-exact-active active"
              @click.prevent="$bvModal.show('modal-transferida')"
            >
              <i class="mdi mdi-rotate-3d-variant"></i> Família Transferida
            </a>
          </p>
        </div>

        <b-button
          :title="$t('Visualizar e Imprimir')"
          :to="'/dashboard/familias/show/' + item.id"
          class="pt-1 mt-3"
          size="sm"
          type="button"
          v-b-tooltip.hover
          variant="primary"
        >
          <i class="mdi mdi-printer mdi-18px" />
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b-tabs content-class="mt-3">
          <b-tab title="ENDEREÇO" active v-if="$store.state.user.role_details.name != 'Nível Básico'">
            <Endereco :item="item" @submit="submit" :localidade="localidades" />
          </b-tab>
          <b-tab title="CONTATO">
            <Contato :item="item" @submit="submit" />
          </b-tab>
          <b-tab title="ANIMAL DE ESTIMAÇÃO">
            <Animal :item="item" />
          </b-tab>
          <b-tab title="MAIS INFORMAÇÕES" v-if="$store.state.user.role_details.name != 'Nível Básico'">
            <form @submit.prevent="submit" ref="addItem">
              <div class="row mt-3">
                <form-select
                  v-model="item.forma_ingresso_cad"
                  label="Forma de coleta de dados"
                  :itens="$root.arrays.forma_ingresso_cad"
                />

                <form-select
                  v-model="item.vulnerabilidades"
                  label="Vulnerabilidade(s)"
                  :multiple="true"
                  :itens="vulnerabilidades"
                />

                <form-select
                  v-model="item.constituicao"
                  grid="6"
                  label="Constituição Familiar Atual"
                  :itens="$root.arrays.constituicao"
                />

                <form-select
                  v-model="item.situacao_rua"
                  grid="6"
                  label="Família em situação de rua?"
                  :itens="$root.arrays.pergunta"
                />

                <form-select
                  :disabled="item.trabalho_infantil != 1 ? false : true"
                  v-model="item.trabalho_infantil"
                  grid="6"
                  label="Trabalho infantil na família?"
                  :itens="$root.arrays.pergunta"
                  alerta="A informação deste campo é originária da importação do cadúnico ou de um registro de Violação de Direitos. Recomendamos que verifique se o valor é compativel com algum registro de VVD com status que confirme a situação. Essa verficação é necessária para garantir a integridade dos dados contabilizados no RMA"
                />
                <form-select
                  v-model="item.catastrofe"
                  grid="6"
                  label="FOI ATINGIDA POR SITUAÇÕES DE EMERGÊNCIA OU ESTADO DE CALAMIDADE PÚBLICA?"
                  :itens="$root.arrays.pergunta"
                />
                <form-select
                  v-model="item.migrante"
                  grid="4"
                  label="Família migrante?"
                  :itens="$root.arrays.pergunta"
                />
                <form-input
                  v-model="item.origem_migrante"
                  grid="4"
                  label="Origem"
                />
                <form-input
                  v-model="item.destino_migrante"
                  grid="4"
                  label="Destino"
                />

                <form-select
                  v-model="item.familia_lgbtqia"
                  grid="12"
                  label="Família composta por membro(s) LGBTQIAPN+?"
                  :itens="$root.arrays.pergunta"
                />

                <form-textarea
                  v-model="item.obs_acolhimento"
                  placeholder="Digite aqui..."
                  grid="12"
                  rows="3"
                  max-rows="6"
                  label="Caso o grupo familiar, em seu conjunto, já tenha vivenciado alguma situação de acolhimento institucional (abrigamento) decorrente da perda, temporária ou definitiva, do domicílio, quer em função de catástrofe natural ou de fatalidade pessoal, registre o período em que o fato ocorreu e o motivo/fato que levou ao acolhimento."
                />

                <form-textarea
                  v-model="item.obs_guarda"
                  placeholder="Digite aqui..."
                  grid="12"
                  rows="3"
                  max-rows="6"
                  label="Caso alguma criança/adolescente da família esteja, ou já tenha estado, sob guarda (legal ou informal) de outra pessoa não residente no domicílio (família extensa, amigos, patrões etc). registre o período em que o fato ocorreu, a razão pela qual ocorreu, a pessoa que esteve com a guarda e o nome da criança/adolescente."
                />
              </div>
              <div class="row mt-3">
                <!-- <form-select
                  v-model="item.status"
                  :itens="$root.arrays.estado_cadastral_familia"
                  label="Status"
                  grid="12"
                  v-if="$store.state.user.role == 1"
                /> -->
                <div class="col-md-6">
                  <a
                    href="#"
                    @click.prevent="$bvModal.show('mais-info')"
                    class="font-weight-light font-italic pt-3"
                    v-if="item.codigo_familiar"
                  >
                    <i class="fas fa-plus"></i> Mais informações do CadÚnico
                  </a>
                </div>

                <!--
                Regra temporariamente desativada:
                v-if="
                  data.item.estado_cadastral_id != 4 &&
                  data.item.estado_cadastral_id != 5
                "
                -->

                <div
                  class="col-md-6 text-right"
                >
                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                  >
                    <i class="mdi mdi-content-save" />
                    {{ $t("Salvar") }}
                  </button>
                </div>
              </div>
            </form>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <ModalMaisInfo :item="item" />
    <ModalTransferida v-if="item.transferencia" :item="item" />
  </div>
</template>
<script>
import Endereco from "./identificacao/Endereco";
import Contato from "./identificacao/Contato";
import Animal from "./identificacao/Animal";
import ModalMaisInfo from "./identificacao/ModalMaisInfo";
import ModalTransferida from "./identificacao/ModalTransferida";
export default {
  props: ["item", "localidades"],
  components: {
    ModalMaisInfo,
    ModalTransferida,
    Endereco,
    Animal,
    Contato,
  },
  data() {
    return {
      vulnerabilidades: {},
    };
  },
  mounted() {
    this.getVulnerabilidades();
    if (this.item.forma_ingresso_cad == null) this.item.forma_ingresso_cad = 0;
  },
  watch: {
    "item.trabalho_infantil": function (val) {
      if (val == 1) {
        swal.fire({
          title: "Alerta",
          html: "Você está marcando este campo como (SIM). Recomendamos que verifique se o valor é compatível com algum registro de Violência Violação de Direitos com status que confirme a situação. Essa verificação é necessária para garantir a integridade dos dados contabilizados no RMA",
          icon: "warning",
        });
      }
    },
  },
  methods: {
    submit() {
      this.$emit("submit");
    },

    getVulnerabilidades() {
      axios.get(`api/dashboard/get/geral/vulnerabilidades`).then((response) => {
        this.vulnerabilidades = response.data;
      });
    },
  },
};
</script>

<style>
.vs__clear {
  display: none !important;
}
</style>
